import React, { createContext, useContext } from 'react';
import { getTenantFromUrl, GYM_CONFIGS } from './Tenant';

const GymContext = createContext();

export const GymProvider = ({ children }) => {
  const tenantKey = getTenantFromUrl();
  const config = GYM_CONFIGS[tenantKey] || GYM_CONFIGS['maple'];
 
  return (
    <GymContext.Provider value={{ tenantKey, brand: config }}>
      {children}
    </GymContext.Provider>
  );
};

export const useGym = () => {
  const context = useContext(GymContext);
  if (context === undefined) {
    throw new Error('useGym must be used within a GymProvider');
  }
  return context;
};